export const walletBalanceKeys = {
  all: ["wallet-balance"] as const,
  summary: () => [...walletBalanceKeys.all, "summary"] as const,
};
